"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pass = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const Base_1 = require("../Base");
const Pass = ({ colour = "currentcolor", size = 16, title = "Pass" }) => (react_1.default.createElement(Base_1.Base, { size: size, title: title, smooth: true },
    react_1.default.createElement("path", { d: "M3,9 6,12 13,4", strokeWidth: 2, stroke: colour, fill: "none" })));
exports.Pass = Pass;
//# sourceMappingURL=Pass.js.map